import { makeAutoObservable } from "mobx";

type TranslationData = { [key: string]: any };
type GlobalError = { key: string; data?: TranslationData; allowClosing?: boolean };

export class GlobalErrorsStore {
  private errors: GlobalError[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  public get hasErrors(): boolean {
    return this.errors.length > 0;
  }

  public hasSpecificErrors(errorKeys: string[]): boolean {
    return this.errors.some(error => errorKeys.includes(error.key));
  }

  public get currentErrors(): GlobalError[] {
    return this.errors;
  }

  public addErrorIfNotExists(key: string, data?: TranslationData, allowClosing = false): void {
    if (!this.errors.find(error => error.key === key && error.data == data)) {
      this.errors.push({ key, data, allowClosing: !!allowClosing });
    }
  }

  public addOrOverrideError(key: string, data?: TranslationData): void {
    console.debug(key, data);

    const existingError = this.errors.find(e => e.key === key);
    if (existingError) {
      existingError.data = data;
      return;
    }

    this.errors.push({ key, data });
  }

  public removeError(key: string): void {
    const reducedErrors = this.errors.filter(e => e.key !== key);

    if (reducedErrors.length != this.errors.length) {
      this.errors = reducedErrors;
    }
  }

  public clearErrors(): void {
    if (this.errors.length) {
      this.errors = [];
    }
  }
}
